import { render } from "./GoogleMaps.vue?vue&type=template&id=2827383f"
import script from "./GoogleMaps.vue?vue&type=script&lang=js"
export * from "./GoogleMaps.vue?vue&type=script&lang=js"

import "./GoogleMaps.vue?vue&type=style&index=0&id=2827383f&lang=scss"

import exportComponent from "C:\\Users\\ricar\\OneDrive\\Ambiente de Trabalho\\Plataforma_eventos\\registar-evento\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__